module.exports = __webpack_public_path__ + "img/send_money.d2aa7411.svg";